"use client";

import React from "react";
import { Heading, Link, ImageWrapper, Rating } from "ui-components";

import CustomerSuccessManager from "@/src/app/[locale]/(private)/profile/[tab]/components/CustomerSuccessManager";
import { BronzeBox } from "@/src/app/[locale]/(public)/about-us/components/membership-boxes/Bronze";
import { EssentialsBox } from "@/src/app/[locale]/(public)/about-us/components/membership-boxes/Essentials";
import { GoldBox } from "@/src/app/[locale]/(public)/about-us/components/membership-boxes/Gold";
import { OtherBox } from "@/src/app/[locale]/(public)/about-us/components/membership-boxes/Other";
import { PlatinumBox } from "@/src/app/[locale]/(public)/about-us/components/membership-boxes/Platinum";
import { SilverBox } from "@/src/app/[locale]/(public)/about-us/components/membership-boxes/Silver";
import { StartUpBox } from "@/src/app/[locale]/(public)/about-us/components/membership-boxes/StartUp";
import { PLACEHOLDER_IMAGE } from "@/src/constants/images";
import { PILOT_MEMBERSHIP } from "@/src/constants/memberships";
import { useOrganizationGetOrganizationDashboard } from "@/src/hooks/api/generated";

export function OrganizationInfomartion({
  organizationId,
}: {
  organizationId?: number;
}): JSX.Element {
  const params = organizationId
    ? { organizationId: String(organizationId) }
    : undefined;
  const { data: organizationData } =
    useOrganizationGetOrganizationDashboard(params);
  const logoImage = organizationData?.organization.organizationImage.find(
    (img) => img?.image?.type === "logo"
  )?.image?.public_id;

  return (
    <div className="w-full md:w-1/5 flex flex-col gap-y-[30px]">
      <Heading variant="h2">Your Organization</Heading>
      <div className="flex flex-col bg-background-dark bg-opacity-20 rounded-large p-5 items-center justify-center text-center gap-y-5">
        <div className="w-20 h-20 rounded-full relative">
          <ImageWrapper
            src={logoImage}
            fill
            alt="Organization Logo"
            className="object-cover rounded-full"
            isCLDImage
            placeholderUrl={PLACEHOLDER_IMAGE}
          />
        </div>
        <Heading variant="h3" align="center">
          {organizationData?.organization.name}
        </Heading>
        <Link href={`/organizations/${organizationData?.organization.slug}`}>
          View your organization profile
        </Link>
      </div>
      {organizationData && organizationData?.rating > 0 && (
        <div className="flex flex-col gap-y-5">
          <Heading variant="h2">Your Rating</Heading>
          <Rating rating={organizationData?.rating} />
        </div>
      )}
      {!organizationId &&
        organizationData?.organization.membership &&
        organizationData?.organization.membership.name !== PILOT_MEMBERSHIP && (
          <div className="flex flex-col gap-y-5">
            <Heading variant="h2">Your Status</Heading>
            {
              {
                Essential: <EssentialsBox isOrganizationProfileVisible />,
                Bronze: <BronzeBox isOrganizationProfileVisible />,
                Silver: <SilverBox isOrganizationProfileVisible />,
                Gold: <GoldBox isOrganizationProfileVisible />,
                Platinum: <PlatinumBox isOrganizationProfileVisible />,
                "Start Up": <StartUpBox isOrganizationProfileVisible />,
                Other: <OtherBox isOrganizationProfileVisible />,
              }[organizationData.organization.membership.name]
            }
          </div>
        )}

      {organizationData?.organization.account_manager && (
        <CustomerSuccessManager
          name={`${organizationData?.organization.account_manager?.first_name} ${organizationData?.organization.account_manager?.last_name}`}
          email={organizationData?.organization.account_manager?.email}
          phone={
            organizationData?.organization.account_manager?.userTaxonomy
              ?.contact_phone ??
            organizationData?.organization.account_manager?.userTaxonomy
              ?.twoFactorPhoneNumber ??
            ""
          }
        />
      )}
    </div>
  );
}
